(function () {

  /* =========================
   * 功能 ① Reviewer 名字旁 Verified
   * ========================= */
function addReviewerVerifiedBadge() {
  document.querySelectorAll('.jm-reviewer-info').forEach(info => {

    // ✅ 1. 已经有 badge → 不加
    if (info.querySelector('.jm-verified-buyer-badge')) return;

    // ✅ 2. 已经有 Verified 文案 → 不加（关键）
    const hasVerifiedText = Array.from(info.querySelectorAll('p, span'))
      .some(el => el.textContent.trim().toLowerCase() === 'verified');

    if (hasVerifiedText) return;

    const nameCluster = info
      .querySelector('.jm-reviewer-info__name')
      ?.closest('.jm-cluster');

    if (!nameCluster) return;

    const badge = document.createElement('div');
    badge.className = 'jm-verified-buyer-badge';
    badge.innerHTML = `
      <p class="jm-text jm-verified-buyer-badge__text"
         style="--text-size: var(--jm-body-xs-size);
                --text-weight: var(--jm-body-xs-weight-medium);">
        Verified
      </p>
    `;

    nameCluster.appendChild(badge);
  });
}

  /* =========================
   * 功能 ② 评分标题 Verified（只一个）
   * ========================= */
  function addAverageRatingVerifiedBadge() {
    const wrapper = document.querySelector('.jm-average-rating-display');
    if (!wrapper) return;

    const cluster = wrapper.querySelector('.jm-cluster');
    if (!cluster) return;

    // 已经有 Verified，就不再加
    if (cluster.querySelector('.jm-verified-badge')) return;

    const badge = document.createElement('div');
    badge.className = 'jm-verified-badge';
    badge.innerHTML = `
      <span class="jm-with-icon"
            role="img"
            aria-label="Verified checkmark"
            style="--jm-icon-space: 0.25em;
                   --jm-icon-justify: flex-start;
                   --jm-icon-align: center;">
        <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M0.684155 0C0.306307 0 0 0.306307 0 0.684155V11.3159C0 11.6938 0.306307 12.0001 0.684155 12.0001H11.3158C11.6937 12.0001 12 11.6938 12 11.3159V6.8211C12 6.60481 11.7364 6.49889 11.5867 6.65505L9.21682 9.1281C8.20419 10.1848 7.14718 10.7102 6.0458 10.7044C4.95311 10.7072 3.91541 10.2173 2.93268 9.23457C1.88908 8.19097 1.33927 7.05861 1.28325 5.8375C1.23923 4.70995 1.67935 3.62286 2.60362 2.57623C2.7207 2.44364 2.92186 2.44188 3.04683 2.56685L5.12772 4.64774C5.25163 4.77165 5.25291 4.97316 5.14469 5.11144C4.64177 5.75402 4.62274 6.30774 5.0876 6.7726C5.55722 7.24222 6.08135 7.17511 6.66 6.57128L11.9333 1.06847C11.9761 1.02379 12 0.964298 12 0.902415V0.684155C12 0.306307 11.6937 0 11.3158 0H0.684155Z" fill="currentColor"></path></svg>
        <p class="jm-text"
           style="--text-size: var(--jm-body-xs-size);
                  --text-weight: var(--jm-body-xs-weight-default);">
          Verified
        </p>
      </span>
    `;
    cluster.appendChild(badge);
  }

  /* =========================
   * 统一执行 & 监听 DOM 变化
   * ========================= */
  function run() {
    addReviewerVerifiedBadge();
    addAverageRatingVerifiedBadge();
  }

  run(); // 初次执行

  const observer = new MutationObserver(run);
  observer.observe(document.body, { childList: true, subtree: true });

})();
